import { render } from "./SubmissionPage.vue?vue&type=template&id=6a8737e4"
import script from "./SubmissionPage.vue?vue&type=script&lang=js"
export * from "./SubmissionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__